/** circuit-tech-nfc removed from catalog; map old saves to creative-portfolio. */
const LEGACY_PRINT_THEME_ID_MAP = {
  'circuit-tech-nfc': 'creative-portfolio',
};

export function resolveSavedPrintThemeId(printThemeId) {
  const id = String(printThemeId || '').trim();
  const mapped = LEGACY_PRINT_THEME_ID_MAP[id];
  return mapped != null ? String(mapped) : id;
}

/** True if saved design refers to this catalog row (numeric id or legacy slug). */
export function savedDesignMatchesTheme(savedId, meta) {
  if (savedId == null || savedId === '') return false;
  const s = String(savedId).trim();
  const effective = resolveSavedPrintThemeId(s);
  if (effective === String(meta.id)) return true;
  if (meta.slug && effective === meta.slug) return true;
  if (s === String(meta.id)) return true;
  if (meta.slug && s === meta.slug) return true;
  return false;
}
